import RSelect from 'react-select'
import styles from './Select.scss'

const Select = ({ options, setValue, value, error }) => {
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      width: '100%',
      // fontFamily: 'suisse-light',
      fontSize: '16px',
      fontWeight: 'normal',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      borderRadius: '8px',
      borderWidth: '1px',
      borderColor: error ? '#d1001a !important' : '#969698 !important',
      boxShadow: 'none',
      height: '60px',
      // fontFamily: 'suisse-light',
      fontSize: '16px',
      fontWeight: 'normal',
      padding: '2px 10px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '12px 15px',
      backgroundColor: state.isSelected ? '#999' : state.isFocused ? '#efefef' : '#fff',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  }

  return (
    <div className={styles.base}>
      <RSelect
        options={Object.values(options)}
        onChange={({ value: v, label }) => setValue(v)}
        value={{ label: options?.find((v) => v.value == value)?.label || '', value }}
        styles={customStyles}
        className="react-select"
      />
    </div>
  )
}

Select.defaultProps = {}
Select.propTypes = {}

export default Select
